import React, { useState, useContext, useEffect } from "react";
import { toast } from "react-toastify";
import { GlobalContext } from "../../../Context/GlobalContext";
import "../../../App.css";
import useOrdersMain from '../../Services/OrdersMainServices/useOrdersMain';

const OrderPaidDetail = ({
  show,
  onClose,
  order,
  amount,
  Admin,
  onSuccess,
  newOrderFlag,
  newOrderFlagUpdate,
}) => {
  const {assignDoorDashOrder, changeCatalogOrderStatus, notifyDriver, assignPartnerAndDispatch}=useOrdersMain();

  const { api, adminId } = useContext(GlobalContext);

  const [userID, setuserID] = useState("");
  const [selectedPartnerType, setSelectedPartnerType] = useState("packky");
  const [deliveryPartnerList, setDeliveryPartnerList] = useState([]);
  const [selectedDeliveryPartner, setSelectedDeliveryPartner] = useState("");
  const [fullAddressState, setFullAddressState] = useState("");
  const [modalData, setModalData] = useState(order || {});
  const [isFoodReadyLoading, setIsFoodReadyLoading] = useState(false);
  const [deliveryPersonName, setDeliveryPersonName] = useState("");
  const [deliveryPersonMobile, setDeliveryPersonMobile] = useState("");

  useEffect(() => {
    if (!order) return;

    setModalData(order);
    setuserID(order.fk_user_id || order.userid || order.us_code || "");

    if (order.address_line) {
      setFullAddressState(order.address_line);
    } else {
      try {
        const obj = JSON.parse(order.address_json || "{}");
        const addr = obj?.values?.address || "";
        const city = obj?.values?.city || "";
        const state = obj?.values?.state || "";
        const pin = obj?.values?.in_pin_code || "";
        const combined = [addr, city, state, pin].filter(Boolean).join(", ");
        setFullAddressState(combined);
      } catch {
        setFullAddressState("");
      }
    }
  }, [order, show]);

  const handleClose = () => {
    setSelectedPartnerType("packky");
    setSelectedDeliveryPartner(null);
    setFullAddressState("");
    setModalData({});
    onClose?.();
  };

  const handleDeliveryPartnerSelection = (partner) => {
    setSelectedDeliveryPartner(partner.id);
    setDeliveryPersonName(partner.contact_name);
    setDeliveryPersonMobile(partner.contact_number);
  };

 const assignDoorDashApi = async (model) => {
  const result = await assignDoorDashOrder({
    orderId: model.orderid,
    userId: userID,
    adminId,
  });

  if (result.success) {
    toast.success(result.message);
  } else {
    toast.error(result.message);
  }

  handleClose();
};

 const TakeWayOrderApi = async (model) => {
  const requestBody = {
    userid: userID || "",
    adminId: adminId ? String(adminId) : undefined,
    orderid: model.orderid,
    productid: "",
    status: "ready_for_takeway",
    time: "",
    payment: "",
  };

  const result = await changeCatalogOrderStatus(requestBody);

  if (result.success) {
    toast.success("Order Dispatched Successfully");
    setModalData({});
    setFullAddressState("");
    onSuccess?.();
  } else {
    toast.error(result.message);
  }
};

const diningOrderApi = async (model) => {
  const payload = {
    userid: userID || "",
    adminId: adminId ? String(adminId) : undefined,
    orderid: model.orderid,
    productid: "",
    status: "ready_for_dinning",
    time: "",
    payment: "",
  };

  const result = await changeCatalogOrderStatus(payload);

  if (result.success) {
    toast.success("Order Dispatched Successfully");
    setModalData({});
    setFullAddressState("");
    onSuccess?.();
  } else {
    toast.error(result.message);
  }
};

 const handleDriverStatusChange = async (
  event,
  orderID
) => {
  const selectedStatus = event.target.value;

  if (!selectedStatus || selectedStatus === "Please select") return;

  setIsFoodReadyLoading(true);

  const payload = {
    userid: userID || "",
    adminId: adminId ? String(adminId) : undefined,
    orderId: orderID,
    orderStatus: selectedStatus,
    deliveryPartner: "packky",
  };

  const result = await notifyDriver(payload);

  if (result.success) {
    toast.success(result.message);
    handleClose();
  } else {
    toast.error(result.message);
  }

  setIsFoodReadyLoading(false);
};

  const assignDeliveryPartner = async (
  model,
  selectedDeliveryPartner
) => {
  const result = await assignPartnerAndDispatch({
    orderid: model.orderid,
    deliveryPersonId: selectedDeliveryPartner,
    userID,
    adminId,
  });

  if (result.success) {
    toast.success(result.message);

    if (!model.delivery_person_name || !model.delivery_person_number) {
      model.delivery_person_name = deliveryPersonName || "";
      model.delivery_person_number = deliveryPersonMobile || "";
    }

    handleClose();
  } else {
    toast.error(result.message);
  }
};

  const orderType = (modalData.orderType || "").toLowerCase();

  if (!show) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50"
      onClick={handleClose}
    >
      <div
        className="w-full max-w-4xl rounded-2xl bg-white shadow-xl"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between border-b px-6 py-4">
          <h2 className="text-lg font-semibold text-gray-800">
            {orderType === "home_delivery"
              ? "Home Delivery"
              : orderType === "takeway"
              ? "Takeaway"
              : "Dining"}
          </h2>
          <button
            onClick={handleClose}
            className="inline-flex h-8 w-8 items-center justify-center rounded-full text-gray-500 hover:bg-gray-100 hover:text-gray-700"
          >
            <span className="sr-only">Close</span>✕
          </button>
        </div>

        <div className="max-h-[70vh] overflow-y-auto px-6 py-4">
          {orderType === "home_delivery" && (
            <div>
              <div className="rounded-xl bg-gray-100 p-3 mb-4">
                <span className="font-semibold text-green-700">
                  Delivery Address:&nbsp;
                </span>
                <span className="font-medium text-gray-800">
                  {fullAddressState}
                </span>
              </div>
              <hr className="my-3" />

              {/* Delivery Service Type Selection */}
              <div className="pb-3">
                <h5 className="flex justify-center text-base font-semibold text-gray-800">
                  Select Delivery Service Type
                </h5>
                <div className="mt-4 flex flex-col gap-3 md:flex-row md:justify-around">
                  {/* Packky */}
                  <label
                    className={`flex h-20 w-56 cursor-pointer items-center justify-center rounded-xl border px-4 text-lg font-medium whitespace-normal text-center transition-all duration-200
                        ${
                          selectedPartnerType === "packky"
                            ? "border-blue-600 bg-blue-50 text-blue-700 shadow-md"
                            : "border-gray-300 bg-white text-gray-700 hover:border-blue-500 hover:bg-blue-100"
                        }
                      `}
                    onClick={() => setSelectedPartnerType("packky")}
                  >
                    <span className="text-center leading-tight">
                      Packky Delivery Service
                    </span>
                  </label>

                  {/* Restaurant */}
                  <label
                    className={`flex h-20 w-56 cursor-pointer items-center justify-center rounded-xl border px-4 text-lg font-medium whitespace-normal text-center transition-all duration-200
                        ${
                          selectedPartnerType === "restaurant"
                            ? "border-blue-600 bg-blue-50 text-blue-700 shadow-md"
                            : "border-gray-300 bg-white text-gray-700 hover:border-blue-500 hover:bg-blue-100"
                        }
                      `}
                    onClick={() => setSelectedPartnerType("restaurant")}
                  >
                    <span className="text-center leading-tight">
                      Restaurant Delivery Service
                    </span>
                  </label>

                  {/* DoorDash */}
                  <label
                    className={`flex h-20 w-56 cursor-pointer items-center justify-center rounded-xl border px-4 text-lg font-medium whitespace-normal text-center transition-all duration-200
                        ${
                          selectedPartnerType === "doordash"
                            ? "border-blue-600 bg-blue-50 text-blue-700 shadow-md"
                            : "border-gray-300 bg-white text-gray-700 hover:border-blue-500 hover:bg-blue-100"
                        }
                      `}
                    onClick={() => setSelectedPartnerType("doordash")}
                  >
                    <span className="text-center leading-tight">
                      DoorDash Delivery Service
                    </span>
                  </label>
                </div>
                <hr className="my-3" />
              </div>

              {/* Restaurant Delivery Partner List */}
              {selectedPartnerType === "restaurant" ? (
                <div>
                  {deliveryPartnerList.map((item) => (
                    <label
                      key={item.id}
                      onClick={() => handleDeliveryPartnerSelection(item)}
                      className={`my-2 block cursor-pointer rounded-2xl border p-3 transition ${
                        item.id === selectedDeliveryPartner
                          ? "border-blue-500 bg-blue-50 text-blue-700"
                          : "border-gray-200 bg-gray-50 hover:border-blue-400"
                      }`}
                    >
                      <div className="flex items-center">
                        <input
                          type="radio"
                          name="deliveryPartner"
                          value={item.id}
                          checked={item.id === selectedDeliveryPartner}
                          onChange={() => handleDeliveryPartnerSelection(item)}
                          className="mr-3 h-4 w-4"
                          style={{ pointerEvents: "none" }}
                        />
                        <div>
                          <div className="text-sm font-semibold text-gray-800">
                            {item.contact_name}
                          </div>
                          <div className="mt-1">
                            {item.active_order_count > 0 ? (
                              <span className="rounded-md bg-white px-2 py-0.5 text-xs font-semibold text-red-600">
                                {item.active_order_count} Active Orders
                              </span>
                            ) : (
                              <span className="rounded-md bg-white px-2 py-0.5 text-xs font-semibold text-green-600">
                                Available
                              </span>
                            )}
                          </div>
                          <div className="mt-1 text-xs text-gray-600">
                            Delivery area: {item.location}
                          </div>
                        </div>
                      </div>
                    </label>
                  ))}
                </div>
              ) : (
                selectedPartnerType === "doordash" && (
                  <div className="py-6 text-center">
                    <div className="mx-auto max-w-md rounded-2xl border border-blue-100 bg-blue-50 px-6 py-5">
                      <h4 className="mb-4 text-lg font-semibold text-blue-700">
                        Delivery Partner Confirmation
                      </h4>
                      <strong className="text-sm text-gray-800">
                        Are you sure you want to assign the delivery partner
                        through
                        <span className="text-red-600"> DoorDash?</span>
                      </strong>
                      <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
                        <button
                          onClick={() => {
                            assignDoorDashApi(modalData);
                            setSelectedPartnerType("doordash");
                          }}
                          className="rounded-full bg-blue-600 px-5 py-2 text-sm font-medium text-white shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-1"
                        >
                          Yes, Assign DoorDash
                        </button>
                        <button
                          onClick={() => {
                            setSelectedPartnerType(null);
                          }}
                          className="rounded-full border border-gray-300 px-5 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-300 focus:ring-offset-1"
                        >
                          No, Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                )
              )}

              {/* Packky Section */}
              {selectedPartnerType === "packky" && (
                <div className="flex flex-col items-center justify-center py-6">
                  {(() => {
                    const dpStatus = (
                      modalData.delivery_partner_status || ""
                    ).toLowerCase();

                    const isAcknowledged = dpStatus === "acknowledged";

                    const isAssigned =
                      dpStatus === "food is ready" ||
                      dpStatus === "successful" ||
                      dpStatus === "assigned" ||
                      !!modalData.delivery_person_name ||
                      !!modalData.delivery_person_number;

                    if (isAcknowledged) {
                      return (
                        <div className="w-full max-w-md rounded-2xl border border-gray-100 bg-gray-50 p-6 shadow-sm">
                          <h5 className="mb-3 text-center text-base font-semibold text-blue-700">
                            Mark Food is Ready
                          </h5>

                          <p className="mb-4 text-center text-sm text-gray-600">
                            Click the button below when the food is packed and
                            ready. This will let the delivery partner know it's
                            time to pick it up.
                          </p>

                          <div className="flex justify-center">
                            <button
                              className={`inline-flex items-center justify-center rounded-full px-8 py-2 text-sm font-medium text-white shadow-sm focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-1 ${
                                isFoodReadyLoading
                                  ? "bg-green-700 cursor-not-allowed opacity-80"
                                  : "bg-green-600 hover:bg-green-700"
                              }`}
                              disabled={isFoodReadyLoading}
                              onClick={() =>
                                handleDriverStatusChange(
                                  { target: { value: "food is ready" } },
                                  modalData.orderid,
                                  modalData,
                                  fullAddressState
                                )
                              }
                            >
                              {isFoodReadyLoading && (
                                <span className="mr-2 inline-block h-4 w-4 animate-spin rounded-full border-2 border-white border-t-transparent"></span>
                              )}
                              {isFoodReadyLoading
                                ? "Processing..."
                                : "Food is Ready"}
                            </button>
                          </div>
                        </div>
                      );
                    }

                    if (isAssigned) {
                      return (
                        <div className="w-full max-w-md rounded-2xl border border-green-100 bg-green-50 p-6 shadow-sm">
                          <h5 className="mb-3 text-center text-base font-semibold text-green-700">
                            Delivery partner has been assigned
                          </h5>
                          <div className="mt-3 rounded-xl bg-white p-4">
                            <h3 className="mb-2 text-sm font-semibold text-gray-800">
                              Delivery Partner Details
                            </h3>
                            <div className="text-sm text-gray-700">
                              <p className="mb-1">
                                <strong>Name:</strong>{" "}
                                {modalData.delivery_person_name || "-"}
                              </p>
                              <p className="mb-1">
                                <strong>Contact:</strong>{" "}
                                {modalData.delivery_person_number || "-"}
                              </p>
                            </div>
                          </div>
                        </div>
                      );
                    }

                    return (
                      <div className="w-full max-w-md rounded-2xl border border-gray-100 bg-gray-50 p-6 text-center shadow-sm">
                        <h5 className="mb-3 text-base font-semibold text-red-600">
                          Waiting for delivery partner
                        </h5>
                        <p className="text-sm text-gray-600">
                          We're currently waiting for the delivery boy to get
                          assigned and start the delivery process.
                        </p>
                      </div>
                    );
                  })()}
                </div>
              )}
            </div>
          )}

          {orderType === "takeway" && (
            <div className="space-y-1">
              <strong className="text-sm font-semibold text-gray-800">
                Takeaway Order
              </strong>
              <p className="text-sm text-gray-600">
                Please prepare the order for pickup.
              </p>
            </div>
          )}

          {orderType === "dining" && (
            <div className="space-y-1">
              <strong className="text-sm font-semibold text-gray-800">
                Dining Order
              </strong>
              <p className="text-sm text-gray-600">
                Order will be served in the restaurant.
              </p>
            </div>
          )}
        </div>

        <div className="flex flex-wrap items-center justify-end gap-3 border-t px-6 py-4">
          {orderType === "home_delivery" &&
            selectedPartnerType !== "doordash" &&
            selectedPartnerType !== "packky" && (
              <button
                onClick={() =>
                  assignDeliveryPartner(
                    modalData,
                    selectedDeliveryPartner,
                    fullAddressState
                  )
                }
                disabled={!selectedDeliveryPartner}
                className={`inline-flex items-center justify-center rounded-full border px-4 py-2 text-sm font-medium transition focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-1 ${
                  !selectedDeliveryPartner
                    ? "cursor-not-allowed border-gray-200 text-gray-400"
                    : "border-blue-600 text-blue-600 hover:bg-blue-50"
                }`}
              >
                Assign Delivery Partner
              </button>
            )}

          {orderType === "takeway" && (
            <button
              onClick={() =>
                TakeWayOrderApi(
                  modalData,
                  modalData.orderid,
                  fullAddressState
                ).catch((error) =>
                  console.error("Error dispatching takeaway order:", error)
                )
              }
              className="inline-flex items-center justify-center rounded-full border border-blue-600 px-4 py-2 text-sm font-medium text-blue-600 hover:bg-blue-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-1"
            >
              Ready For Takeaway
            </button>
          )}

          {orderType === "dining" && (
            <button
              onClick={() => diningOrderApi(modalData)}
              className="inline-flex items-center justify-center rounded-full border border-blue-600 px-4 py-2 text-sm font-medium text-blue-600 hover:bg-blue-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-1"
            >
              Ready for Dining
            </button>
          )}

          <button
            onClick={handleClose}
            className="inline-flex items-center justify-center rounded-full border border-gray-400 px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-400 focus:ring-offset-1"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default OrderPaidDetail;
